<template>
  <b-button
    @click="share()"
    rounded
    :style="types[status]"
  >
    {{ btnLabel }}
  </b-button>
</template>
<script>
export default {
  name: 'ShareBtn',
  props: {
    url: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: 'Partager'
    }
  },

  data () {
    return {
      status: "default",
      types: {
        default: null,
        success: "background-color: #effaf5; color: #3f8a68;",
        failed: "background-color: #feecf0; color: #d43454;"
      },
      labels: {
        default: "Copier",
        success: "Lien copié !",
        failed: "Erreur ..."
      }
    }
  },

  computed: {
    btnLabel () {
      if (this.status === 'success' || this.status === 'failed') {
        return this.labels[this.status];
      } else {
        return this.label
      }
    }
  },

  methods: {
    async share () {
      try {
        await navigator.share({
          title: this.title,
          url: this.url
        })
      } catch (err) {
        navigator
          .clipboard
          .writeText(this.url)
          .then(
            () => {
              this.status = "success";
              },
            () => {
              this.status = "failed";
            });
        setTimeout(() => {
          this.status = "default";
        }, 3000);
      }
    }
  }
}
</script>
